module.exports = __webpack_public_path__ + "img/selected1-min.95f1021e.png";